import { gql } from 'apollo-angular';
import { baseResponseGraphqlField } from '../../../base.graphql';
export const citizenGroupSummaries = `
groupName
serviceCounts
`;

export const GET_CITIZEN_GROUP_SUMMARIES = gql`
query citizenGetGroupSummaries{
    citizenGetGroupSummaries{
    ${baseResponseGraphqlField}
    data {
      ${citizenGroupSummaries}
    }
  }
}
`;